import React from 'react'
import { Modal, Spin } from 'antd'
import BusinessForm from './BusinessForm';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { LoadingOutlined } from "@ant-design/icons";

export default function AddBusiness() {

    const general = useGeneralStore();
    const { business, getBusinesses } = usePersistedStore();
    const visibleNew = general.view?.businessNewEditModal;
    const currentBusiness = business.businesses?.byToken;
    const loading = business.businesses.loading;

    return (
        <div>
            <Modal
                style={{ top: 80 }}
                width='90%'
                className="custom-table"
                maxWidth='600px'
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {loading && <LoadingOutlined spin />}
                        <span>
                            {loading ? "" : <h3 style={{ color: "var(--text-strong, #333333)", fontWeight: "600" }}
                                className='mb-2'>بروزرسانی شریک تجاری {currentBusiness?.name ? `- ${currentBusiness.name}` : ''}</h3>}
                        </span>
                    </div>
                }
                open={visibleNew}
                footer={false}
                onCancel={() => general.ToggleBusinessNewEditModal()}>
                <Spin style={{ marginTop: "10px" }} spinning={loading}>
                    <div>
                        <BusinessForm
                            showInfoItems={true}
                            onSubmit={() => { getBusinesses(); }}
                            business={currentBusiness} />
                    </div>
                </Spin>
            </Modal>
        </div>
    )
}